import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Default navigation settings
 */
const navigationSettings = {
    mobile: {
        hidden: false
    },
    desktop: {
        hidden: false
    }
};
class NavigationService {
    constructor() {
        this._onNavigationChanged = new BehaviorSubject(navigationSettings);
    }
    /**
     * Get navigation settings
     * @returns Observable<NavigationSettings>
     */
    get onNavigationChanged() {
        return this._onNavigationChanged.asObservable();
    }
    /**
     * Set mobile navigation visibility
     */
    _setMobileNavVisibility(hidden) {
        const currentValue = this._onNavigationChanged.getValue();
        this._onNavigationChanged.next({ ...currentValue, mobile: { hidden } });
    }
    /**
     * Set desktop navigation visibility
     */
    _setDesktopNavVisibility(hidden) {
        const currentValue = this._onNavigationChanged.getValue();
        this._onNavigationChanged.next({ ...currentValue, desktop: { hidden } });
    }
    /**
     * Set navigation settings
     * @param config
     */
    setConfig(config) {
        const currentValue = this._onNavigationChanged.getValue();
        this._onNavigationChanged.next({ ...currentValue, ...config });
    }
    /**
     * Hide mobile navigation
     */
    hideMobileNav() {
        this._setMobileNavVisibility(true);
    }
    /**
     * Show mobile navigation
     */
    showMobileNav() {
        this._setMobileNavVisibility(false);
    }
    /**
     * Hide desktop navigation
     */
    hideDesktopNav() {
        this._setDesktopNavVisibility(true);
    }
    /**
     * Show desktop navigation
     */
    showDesktopNav() {
        this._setDesktopNavVisibility(false);
    }
    /**
     * Restore navigation settings to default
     */
    restoreDefaults() {
        this._onNavigationChanged.next(navigationSettings);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NavigationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NavigationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { NavigationService, navigationSettings };
